import React, { Component } from "react";
import PozadinaImage from "../../images/home-three-1-1920x800.jpg";

class MainBookingSectionComponent extends Component {
  render() {
    return (
      <section
        className="jumbotron-custom jumbotron-custom-3 bg-white bg-image bg-image-custom bg-image-center"
        style={{ backgroundImage: "url(" + PozadinaImage + ")", paddingTop: 170 }}
        id="mainsection"
      >
        <div className="jumbotron-custom-content text-center">
          <div className="shell">
            <div className="range range-sm-center">
              <div className="cell-sm-9 cell-md-8 cell-lg-7">
                <h1 style={{fontFamily: "Windsong", fontSize:100}}>Dobrodošli</h1> <h2 style={{textTransform:"capitalize"}}> <br/>Atelje Stojčić</h2>
                <p className="large">
                  
                </p>
                <a
                  className="btn btn-style-1 btn-white-pickled-bluewood btn-circle btn-shadow"
                  href="/zakazivanje"
                >
                  ZAKAŽI SADA
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default MainBookingSectionComponent;
